import React, { createRef, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Tree, Input, Col, Spin, Checkbox } from 'antd';
import { FolderOpenOutlined, SearchOutlined } from '@ant-design/icons';
import { isEqual, cloneDeep, debounce } from 'lodash';
import { callApi } from 'utils';
const TreeNode = Tree.TreeNode;
const prefixClx = 'select-modal-new';
import { SelectContext } from '../context';

// 查询组件类型
const componentType = {
	USER: 'user',
	DEPARTMENT: 'department',
	STATION: 'station',
	ALL: 'all',
};

class SelectDepartment extends PureComponent {
	static contextType = SelectContext;
	constructor (props) {
		super(props);
		this.state = {
			expandedKeys: [],
			selectedKeys: props.selects.filter(val => val.flowUserSelectionType === 'department' || val.sourceTypeA === 'source_department').map(val => String(val.sourceIdA)),
			disabledObj: this.getDisabledObj(props.disabledSelects),
			organizations: {},
			scrollViewHeight: 0,
		};
		this.treeBox = createRef();
		this.searchBox = createRef();
	}

	componentDidMount () {
		const { organizations  } = this.props;
		let scrollViewHeight = 0;
		if(this.treeBox.current && this.searchBox.current) {
			const searchBox = window.getComputedStyle(this.searchBox.current)
			scrollViewHeight = this.treeBox.current.parentElement.clientHeight - parseInt(searchBox.height) - parseInt(searchBox.marginTop) - parseInt(searchBox.marginBottom)
		}
		this.setState({
			expandedKeys: [String(organizations.id)],
			scrollViewHeight,
		})
		this.initTree();
	}

	componentWillReceiveProps (nextProps) {
		const { organizations } = this.props;
		const { selects } = nextProps;
		if (organizations !== nextProps.organizations && nextProps.organizations) {
			this.initTree(nextProps.organizations);
		}
		if (!isEqual(this.props.selects, selects)) {
			this.setState({
				selectedKeys: selects.filter(val => val.flowUserSelectionType === 'department').map(val => String(val.sourceIdA))
			});
		}
	}

	//封装不可选择列表
	getDisabledObj = (disabledList = []) => {
		const obj = {};
		disabledList.filter(val => val.flowUserSelectionType === 'department').forEach(val => {
			obj[Number(val.sourceIdA)] || (obj[Number(val.sourceIdA)] = true);
		});
		return obj;
	}

	/**
	 * 初始化所有部门
	 */
	initTree = () => {
		this.setState({
			loading: true
		});
		const { organizations, hiddenFilterFlag = 0, isLazyLoadData } = this.props;
		const { manageSceneFlag } = this.context;
		let api = '';
		if(isLazyLoadData) {
			api = '/org_v6/listOrganizationsByComponentV1';
		} else {
			api = '/org_v6/listOrganizationsByComponent';
		}
		const data = {
			manageSceneFlag,
			organizationId: organizations.id,
			componentType: componentType.DEPARTMENT,
			appId: window.$$context.appId,
			hiddenFilterFlag,
		};
		callApi({
			api,
			data,
			success: ({ organizationTree = {} }) => {
				this.setState({
					organizations: organizationTree,
					loading: false,
				});
			},
			error: () => {
				this.setState({
					loading: false
				});
			}
		});
	}

	lazyLoadOrganization = ({ allData, children }) => {
		if(children) {
			return Promise.resolve();
		}
		const { id: organizationId } = allData;
		if(!organizationId){
			return Promise.reject();
		}
		const { hiddenFilterFlag = 0 } = this.props;
		const { manageSceneFlag } = this.context;

		const data = {
			organizationId,
			componentType: componentType.DEPARTMENT,
			appId: window.$$context.appId,
			hiddenFilterFlag,
			manageSceneFlag
		};
		return callApi({
			api: '/org_v6/listOrganizationsByComponentV1',
			data,
			success: res => {
				const organizations = res.organizationTree;
				Object.assign(allData, organizations);
				this.setState(({ organizations }) => ({
					organizations: {
						...organizations,
					}
				}))
			}
		});
	}

	/**
	 * 生成部门组织树状数据结构
	 */
	generateNodes = (list) => {
		const { disabledTip, selects, isLazyLoadData } = this.props;
		const { disabledObj } = this.state;
		return list.map(node => {
			const { children, name, id, selectedFlag, path, isLeaf } = node;
			const nodeDisabled = disabledObj[id] || selectedFlag === 0;
			let disabledText = '';
			if (disabledObj[id]) {
				disabledText = disabledText || disabledTip;
			}
			if (selectedFlag === 0) {
				disabledText = disabledText || '无权限';
			}
			if (children && children.length > 0) {
				const parentsSelected = (() => {
					if (nodeDisabled) {
						return false;
					}
					return selects.some(selectNode => String(selectNode.sourceIdA) === String(id) && selectNode.sourceTypeA === 'source_department');
				})();
				return (
					<TreeNode
						disabled={nodeDisabled}
						allData={node}
						key={String(id)}
						isLeaf={ isLazyLoadData && !!isLeaf }
						title={
							<div title={disabledText || null} className={`${prefixClx}-node`}>
								<span className={`${prefixClx}-node-name`}>
									<FolderOpenOutlined className='type-icon' />{name}
								</span>
								<span className={`${prefixClx}-node-handle`}>
									<Checkbox disabled={nodeDisabled} checked={parentsSelected} />
								</span>
							</div>
						}>
						{this.generateNodes(children)}
					</TreeNode>
				);
			}
			const selected = (() => {
				if (nodeDisabled) {
					return false;
				}
				return selects.some(selectNode => String(selectNode.sourceIdA) === String(id) && selectNode.sourceTypeA === 'source_department');
			})();
			return (
				<TreeNode
					disabled={nodeDisabled}
					allData={node}
					key={String(id)}
					isLeaf={isLazyLoadData ? !!isLeaf : true}
					title={
						<div title={name} className={`${prefixClx}-node`}>
							<span className={`${prefixClx}-node-name`}>
								<FolderOpenOutlined className='type-icon' />
								{name}
							</span>
							<span className={`${prefixClx}-node-handle`}>
								<Checkbox disabled={nodeDisabled} checked={selected} />
							</span>
						</div>
					} />
			);
		});
	}

	/**
	 * 生成搜索结果数据结构
	 */
	generateList = list => {
		const { disabledTip, selects } = this.props;
		const { disabledObj } = this.state;
		return list.map(node => {
			const { name, id, selectedFlag } = node;
			const nodeDisabled = disabledObj[id] || selectedFlag === 0;
			let disabledText = '';
			if (disabledObj[id]) {
				disabledText = disabledText || disabledTip;
			}
			if (selectedFlag === 0) {
				disabledText = disabledText || '无权限';
			}
			const selected = (() => {
				if (nodeDisabled) {
					return false;
				}
				return selects.some(selectNode => selectNode.sourceIdA === String(id) && selectNode.sourceTypeA === 'source_department');
			})();
			return (
				<TreeNode
					disabled={nodeDisabled}
					allData={node}
					key={String(id)}
					title={
						<div title={disabledText || null} className={`${prefixClx}-node`}>
							<span className={`${prefixClx}-node-name`}>
								<FolderOpenOutlined className='type-icon' />
								{name}
							</span>
							<span className={`${prefixClx}-node-handle`}>
								<Checkbox disabled={nodeDisabled} checked={selected} />
							</span>
						</div>
					} />
			);
		});
	};

	/**
	 * 选中树节点
	 */
	selectTreeNode = (keys, info) => {
		const { props } = this;
		const sNode = info.node;
		const param = {
			selectedKeys: keys
		};
		if (sNode) {
			const newSelect = {
				selectionName: sNode.allData.name,
				flowUserSelectionType: 'department',
				sourceIdA: sNode.key,
				sourceTypeA: 'source_department',
				sourceDataA: props.needAllData ? sNode.allData : undefined,
			};
			if (info.selected) {
				props.addItems([newSelect]);
			} else if (!info.selected) {
				props.removeItems([newSelect]);
			}
		}

		this.setState(param);
	}

	/**
	 * 点击展开/收缩树节点
	 */
	onExpand = (keys, info) => {
		this.setState({ expandedKeys: keys });
	}

	/**
	 * 根据关键字搜索
	 */
	searchByKeywords = (keywords = '') => {
		const { organizations, privilegeFilterFlag = 0, hiddenFilterFlag = 0 } = this.props;
		const { manageSceneFlag } = this.context;
		keywords = keywords.trim();
		if (keywords) {
			this.setState({ loading: true, showSearchBox: true, searchText: keywords, });
			callApi({
				api: '/newOrg/findOrgPersonal',
				data: {
					organizationId: organizations.id,
					keywords,
					privilegeFilterFlag,
					appId: window.$$context.appId,
					hiddenFilterFlag,
					manageSceneFlag
				},
				success: ({ departments = [] }) => {
					this.setState({
						searchList: departments,
						loading: false,
					});
				}
			});
		} else {
			this.setState({
				loading: true,
				showSearchBox: true,
				searchList: [],
				searchText: keywords,
			}, () => {
				this.setState({
					loading: false
				});
			});
		}
	}

	// 防抖
	searchByKeywordsDebounced = debounce(this.searchByKeywords, 500);

	render () {
		const { expandedKeys, selectedKeys, organizations, searchText, showSearchBox, loading, searchList = [], scrollViewHeight } = this.state;
		return (
			<Col className='tree-box' ref={this.treeBox}>
				<div className='select-box-search' ref={this.searchBox}>
					<Input
						placeholder="请输入部门"
						prefix={<SearchOutlined />}
						onChange={e => this.searchByKeywordsDebounced(e.target.value)}
						allowClear
					/>
				</div>
				<div className={'select-scroll-view'}>
					{
						showSearchBox && searchText
							? loading
								? <Spin className='tree-box-center' />
								: searchList.length < 1
									? <div className='tree-box-center'>未找到相关结果</div>
									: <Tree
										multiple
										height={scrollViewHeight}
										autoExpandParent={false}
										expandedKeys={expandedKeys}
										selectedKeys={selectedKeys}
										onSelect={this.selectTreeNode}
										onExpand={this.onExpand}
									>
										{this.generateList(searchList)}
									</Tree>
							: loading ? <Spin className='tree-box-center' /> : <Tree
								multiple
								height={scrollViewHeight}
								autoExpandParent={false}
								expandedKeys={cloneDeep(expandedKeys)}
								selectedKeys={selectedKeys}
								onSelect={this.selectTreeNode}
								onExpand={this.onExpand}
								loadData={this.lazyLoadOrganization}
							>
								{this.generateNodes([organizations])}
							</Tree>

					}
				</div>
			</Col>
		);
	}
}

SelectDepartment.propTypes = {
	organizations: PropTypes.object.isRequired, // 组织架构数据
	// 选中的列表， 数据结构为 [{selectionName: 显示名称, flowUserSelectionType: 'department', sourceIdA: ID, sourceTypeA: 'source_department'}]

	/* 以下是configs额外传进来的参数 */
	useDisable: PropTypes.bool,
	disabledSelects: PropTypes.array.isRequired,
	selects: PropTypes.array.isRequired,
	// 是否支持选择 '包含子部门'
	selectChild: PropTypes.bool,
	addItems: PropTypes.func.isRequired,		// 选中一个条目的回调
	removeItems: PropTypes.func.isRequired,		// 祛选中一个条目的回调
	// 禁用提示语
	disabledTip: PropTypes.string,
	hiddenFilterFlag: PropTypes.number,
	isLazyLoadData: PropTypes.bool, // 是否使用对数据进行懒加载的功能
	lazyLoadOrganization: PropTypes.func, // 使用懒加载数据的时候，需要在获取子部门时调用的方法
};
export default SelectDepartment;
